var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProviderEarning = function SvgProviderEarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141416",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.755,
    d: "M24.213 24c4.419-4.418 4.419-11.582 0-16s-11.581-4.418-16 0c-4.418 4.418-4.418 11.582 0 16s11.582 4.418 16 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141416",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.755,
    d: "M17.516 27.004c6.077-1.454 9.825-7.558 8.372-13.635-1.454-6.077-7.559-9.826-13.636-8.372-6.076 1.453-9.825 7.558-8.371 13.635s7.558 9.825 13.635 8.372Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#141416",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.755,
    d: "M17 24.847a9.096 9.096 0 1 0-4.228-17.694 9.096 9.096 0 0 0 4.229 17.694Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#141416",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.755,
    d: "M6.572 16a9.096 9.096 0 0 1 8.707-9.085h-.392a9.096 9.096 0 0 0 0 18.193h.392A9.094 9.094 0 0 1 6.572 16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.755,
    d: "M23.317 7.275h-.866M24.416 8.298h-.629M25.83 9.868h-.707M26.614 11.832h-.941M27.322 13.955h-.863M27.322 18.43h-.942M23.63 23.775h.786M22.293 24.795h.866M20.881 25.894h.863M21.823 6.175h-1.337"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.476 10.497v2.095c0 .114-.061.214-.152.27l-.013.008-.489.282-2.84 1.64-.344.198-.001.001-.017.01a.158.158 0 0 0 .013.27l.39.225 1.33.768.024.014c.042.028.068.076.068.13 0 .053-.026.1-.068.129l-.023.013-2.43 1.402-.013.008a.31.31 0 0 1-.286.008l-.014-.008-.02-.012-1.407-.812-.466-.27-.013-.007a.3.3 0 0 1-.11-.112.3.3 0 0 1-.042-.157v-2.187c0-.113.06-.212.148-.267l.004-.003.016-.008.002-.002.461-.266 1.555-.898 1.875-1.082 2.616-1.51.013-.008a.158.158 0 0 1 .233.138"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.662 14.973v2.187a.32.32 0 0 1-.165.277l-.466.27-.59.34-.965.557-1.875 1.082-2.616 1.51-.013.008a.158.158 0 0 1-.233-.138V18.97a.32.32 0 0 1 .171-.28l.482-.28 2.84-1.639.34-.196h.002l.021-.013.003-.002a.158.158 0 0 0-.003-.26l-.015-.01-.39-.224-1.329-.767-.026-.015a.16.16 0 0 1-.066-.129c0-.053.025-.099.065-.127h.001l.026-.016.005-.002 2.421-1.399.019-.01a.31.31 0 0 1 .292-.001l.021.012 1.411.814.466.27.013.007a.3.3 0 0 1 .11.112q.041.07.042.158"
  })));
};
export default SvgProviderEarning;